module.exports = __webpack_public_path__ + "static/media/circle-red.7c7e154e.svg";